import DocumentToolbar from "../common/DocumentToolbar";
import useInvoiceSaveKey from "../../hooks/useInvoiceSaveKey";
// === src/components/intrare/Create.jsx ===
import React, { useEffect, useMemo, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Alert,
} from "react-bootstrap";
import { authFetch } from "../utils/authFetch";
import { toast } from "react-toastify";
import IntrareForm from "./Form";
import { useLocation, useSearchParams } from "react-router-dom";
import { changeIntrareDocument } from "../utils/documentClassification";
// aceleași reguli de normalizare ca în Edit.jsx

function normalizeIntrare(m) {
  if (!m) return null;
  const {
    id,
    created_at,
    updated_at,
    user_id,
    contact_name,
    total,
    total_tva,
    total_fara_tva,
    linii = [],
    ...rest
  } = m;

  const normLinii = [...linii]
    .map(({ id, created_at, updated_at, _tmp, ...ln }) => ln)
    .sort((a, b) => {
      const ka = a.crt ?? a.bxpart_id ?? 0;
      const kb = b.crt ?? b.bxpart_id ?? 0;
      return ka === kb ? 0 : ka < kb ? -1 : 1;
    });

  return { ...rest, linii: normLinii };
}

const hash = (obj) => JSON.stringify(obj);

const todayISO00 = () => new Date().toISOString().slice(0, 10) + "T00:00:00";
const todayPlus30 = () => {
  const d = new Date();
  d.setDate(d.getDate() + 30);
  return d.toISOString().slice(0, 10) + "T00:00:00";
};

// un „model gol” minim — ajustează cu câmpurile tale implicite
const EMPTY_MODEL = {
  tip_document: "Factura",
  doc_type: "Facturi intrare",
  account_id: null,
  contact_id: 0,
  tip_factura: 1,
  tip_factura_label: "Normală",
  bxdoc_no: "",
  bxdoc_date: todayISO00(),
  bxinput_date: todayISO00(),
  bxdatascadenta: todayPlus30(),

  bxvaluta_id: 1,
  bxvaluta_curs: "1.0000",

  bxgvalue: "0.00",
  bxsold: "0.00",
  bxsettled_value: "0.00",

  observatii: "",
  comanda_client: "",
  proiect_client: "",
  bxfinal_bool: false,
  bxsoldint: 0,

  linii: [],
};

export default function IntrareCreate() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const menuDocumentType = searchParams.get("tip_document") === "Aviz" ? "Aviz" : null;

  const [initialForm, setInitialForm] = useState(() => menuDocumentType ? changeIntrareDocument(EMPTY_MODEL, menuDocumentType) : EMPTY_MODEL);
  const [form, setForm] = useState(initialForm);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [supplierAcc, setSupplierAcc] = useState(null);
  const fixedDocumentType = menuDocumentType ||
    (Number(supplierAcc?.id) === Number(form.bxcont_id) && String(supplierAcc?.code || supplierAcc?.bxcod || supplierAcc?.bxcont_code || "").startsWith("408") ? "Aviz" : null);
  const originalHash = useMemo(
    () => hash(normalizeIntrare(initialForm)),
    [initialForm],
  );
  const currentHash = useMemo(() => hash(normalizeIntrare(form)), [form]);
  const isDirty = originalHash !== currentHash;

  // const codAccount =
  //   accounts?.find((a) => Number(a.id) === Number(form.bxcont_id))?.code || "";
  useEffect(() => {
    console.log("FORM CHANGED:", form);
  }, [form]);


  const todayISO00 = () => new Date().toISOString().slice(0, 10) + "T00:00:00";

  const buildIntrarePayload = (v) => ({
    tip_document: fixedDocumentType || v.tip_document || "Factura",
    // ✅ REQUIRED de backend
    tip_factura: fixedDocumentType === "Aviz" ? 2 : (v.tip_factura ?? 1),

    bxdoc_no: v.bxdoc_no ?? "",
    bxdoc_date: v.bxdoc_date ?? v.doc_date ?? todayISO00(),

    bxvaluta_id: v.bxvaluta_id ?? 1,
    bxvaluta_curs: v.bxvaluta_curs ?? "1.0000",
    bxcurs_invoice: v.bxcurs_invoice ?? null,

    bxgvalue: String(v.bxgvalue ?? "0.00"),
    bxsold: String(v.bxsold ?? v.bxgvalue ?? "0.00"),
    bxsoldint: Number(v.bxsoldint ?? 0),

    // rest
    bxcont_id: v.bxcont_id ?? v.account_id ?? null,
    bxinput_date: v.bxinput_date ?? null,
    bxdatascadenta: v.bxdatascadenta ?? null,
    contact_id: v.contact_id ?? 0,
    observatii: v.observatii ?? "",
    comanda_client: v.comanda_client ?? "",
    proiect_client: v.proiect_client ?? "",
    bxfinal_bool: !!v.bxfinal_bool,
    e_tva_inc: v.e_tva_inc != null ? Number(v.e_tva_inc) : 0,

    linii: (v.linii || []).map((ln) => ({
      source_aviz_line_id: ln.source_aviz_line_id ?? null,
      bxcomanda_id: ln.bxcomanda_id ?? null,
      bxpart_id: ln.bxpart_id ?? 0,
      bxgestiune_id: ln.bxgestiune_id ?? 0,
      bxum_id: ln.bxum_id ?? 1,
      bxcantitate: Number(ln.bxcantitate) || 0,
      bxvprice: Number(ln.bxvprice) || 0,
      bxvamount: Number(ln.bxvamount) || 0,
      bxvatv_amount: Number(ln.bxvatv_amount) || 0,
      bxtotalv_amount: Number(ln.bxtotalv_amount) || 0,
      bxvat_id: ln.bxvat_id ?? 1,
      bxdescr: ln.bxdescr ?? "",
      cost_alloc: ln.cost_alloc ?? "",
      bxcont_id: ln.bxcont_id ?? null,
      bxstocin_id: ln.bxstocin_id ?? null,
    })),
  });

  const location = useLocation();
  const ctx =
    location.state ||
    (() => {
      try {
        return JSON.parse(localStorage.getItem("intrare_ctx") || "null");
      } catch {
        return null;
      }
    })();

  const accountCode = ctx?.accountCode || "";
  const accountLabel = ctx?.accountLabel || "";

  const queryBxsoldint = searchParams.get("bxsoldint");
  const queryAccountId = searchParams.get("account_id");

  useEffect(() => {
    const qAccId = Number(queryAccountId || ctx?.accountId || "");
    const qSoldInt = Number(queryBxsoldint || 0);

    if (qAccId > 0 || qSoldInt > 0) {
      setForm((prev) => {
        const next = { ...prev };
        if (qAccId > 0) next.bxcont_id = qAccId;
        if (qSoldInt > 0) next.bxsoldint = qSoldInt;
        return next;
      });
      setInitialForm((prev) => {
        const next = { ...prev };
        if (qAccId > 0) next.bxcont_id = qAccId;
        if (qSoldInt > 0) next.bxsoldint = qSoldInt;
        return next;
      });
    }
  }, [queryAccountId, queryBxsoldint, ctx?.accountId]);

  const allocationRef = useRef(null);
  const saveKey = useInvoiceSaveKey();
  const saveInFlight = useRef(false);
  const save = async () => {
    if (saveInFlight.current) return;
    saveInFlight.current = true;
    setSaving(true);
    setError("");
    try {
      const payload = await allocationRef.current.prepare(buildIntrarePayload(form));
      console.log("FINAL POST payload:", JSON.stringify(payload));

      const data = await authFetch("/intrare/", {
        method: "POST",
        headers: { "Idempotency-Key": saveKey.get() },
        body: JSON.stringify(payload),
      });

      toast.success("Intrarea a fost creată cu succes!");
      navigate(`/intrare/${data.id}/edit`);
    } catch (e) {
      setError(String(e?.message || e));
      toast.error(`Eroare la salvare: ${e?.message || e}`);
    } finally {
      saveInFlight.current = false;
      setSaving(false);
    }
  };

  useEffect(() => {
    if (!form?.bxcont_id) {
      setSupplierAcc(null);
      return;
    }

    (async () => {
      try {
        const acc = await authFetch(`/accounts/${form.bxcont_id}`);
        setSupplierAcc(acc);
      } catch (err) {
        console.error("Eroare încărcare cont furnizor", err);
        setSupplierAcc(null);
      }
    })();
  }, [form?.bxcont_id]);

  const saveAndNew = async () => {
    if (saveInFlight.current) return;
    saveInFlight.current = true;
    setSaving(true);
    setError("");
    try {
      const payload = await allocationRef.current.prepare(buildIntrarePayload(form));
      await authFetch("/intrare/", {
        method: "POST",
        headers: { "Idempotency-Key": saveKey.get() },
        body: JSON.stringify(payload),
      });

      toast.success("Intrarea a fost creată cu succes!");
      // curățăm doar la succes
      saveKey.reset();
      const fresh = {
        ...(fixedDocumentType ? changeIntrareDocument(EMPTY_MODEL, fixedDocumentType) : EMPTY_MODEL),
        bxcont_id: form.bxcont_id ?? null,
        bxsoldint: form.bxsoldint ?? 0,
        bxdoc_date: todayISO00(),
      };
      setForm(fresh);
      setInitialForm(fresh);
    } catch (e) {
      setError(String(e?.message || e));
      toast.error(`Eroare la salvare: ${e?.message || e}`);
    } finally {
      saveInFlight.current = false;
      setSaving(false);
    }
  };

  return (
    <Container className="py-3">
      <DocumentToolbar
        title={fixedDocumentType === "Aviz" ? "Creează aviz furnizor" : form.bxsoldint === 1 ? "Factură inițială furnizor" : "Creează intrare"}
        dirty={isDirty} newDocument error={error} busy={saving}
        onBack={() => {
          const accId = form.bxcont_id || ctx?.accountId;
          if (accId) navigate(`/intrare/intrare_list/${accId}${form.bxsoldint === 1 ? "?bxsoldint=1" : ""}`);
          else navigate(-1);
        }}
        onSave={save} saveDisabled={!isDirty}
        actions={[{ label: "Salvează și creează altul", onClick: saveAndNew, disabled: !isDirty }]}
      />

      {error && <Alert variant="danger">{error}</Alert>}

      {/* <IntrareForm
        initial={form}
        onChange={setForm}
        onSubmit={save}
        submitting={saving}
      /> */}
      <IntrareForm
        allocationRef={allocationRef}
        fixedDocumentType={fixedDocumentType}
        value={form}
        onChange={setForm}
        onSubmit={save}
        // locked={locked}
      />

    </Container>
  );
}
